<template>
  <div class="related-tasks" v-if="tasks.length > 1" data-qid="related-asset-tasks">
    <div class="related-tasks__title">
      <font-awesome-icon :icon="isControl ? 'shield-alt' : 'tasks'" class="mr-1"/>
      {{ $t(isControl ? 'tasks.related_tasks.controls_title' : 'tasks.related_tasks.title', { name: assetName, count: tasks.length }) }}
    </div>
    <div class="related-tasks__list">
      <span v-for="item in tasks"
            :key="'related-task-' + item.id"
            class="related-tasks__item"
            :class="{'related-tasks__item--on': item.id === task.id}"
            :aria-current="item.id === task.id ? 'true' : null"
            @click="item.id !== task.id && $emit('open', item)"
            data-qid="related-asset-task"
      >
        <font-awesome-icon :icon="statusIcon(item)" :class="'related-tasks__status related-tasks__status--' + statusKey(item)"/>
        <span class="text-truncate">{{ label(item) }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';

// The other tasks of the project on the same asset, to move between them in the task panel (US 9478)
export default {
  name: 'RelatedAssetTasks',
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      tasks: []
    }
  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
    // Controls and security measures are named after the control; the other tasks after what to do
    isControl() {
      return this.task.code === 'control' || this.task.code === 'security_measure';
    },
    assetName() {
      return this.task.model ? this.task.model.name : '';
    },
    // Changes when another task is opened, also on another asset
    key() {
      const project = this.task.project ? this.task.project.slug : '';
      return [project, this.task.model_type, this.task.model_id].join('|');
    }
  },
  watch: {
    key: {
      handler() {
        this.load();
      },
      immediate: true
    }
  },
  methods: {
    load() {
      const self = this;
      if (!this.task.project || !this.task.project.slug || !this.task.model_type || !this.task.model_id) {
        this.tasks = [];
        return;
      }
      piincHttp.get('projects/' + this.task.project.slug + '/tasks', { params: {
        model_type: this.task.model_type,
        model_id: this.task.model_id,
        per_page: 100,
        client: this.getClient.slug
      }}).then(function(response) {
        self.tasks = response.data.items || [];
      }, function() {
        self.tasks = [];
      });
    },
    label(item) {
      return this.isControl ? item.title : this.$t('tasks.values.' + this.$options.filters.slugify(item.title));
    },
    statusKey(item) {
      return item.status === 'completed' ? 'completed' : (item.status === 'in progress' ? 'progress' : 'pending');
    },
    statusIcon(item) {
      const icons = { completed: 'check-circle', progress: 'clock', pending: 'circle' };
      return icons[this.statusKey(item)];
    }
  }
}
</script>
